module.exports = __webpack_public_path__ + "img/chat-head.321051cb.png";